import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SETTINGS } from '../../../../../clpbp-app.settings';

// Documentation: https://confluence.loandepot.com/display/CLP/Iovation#Iovation-Integration
@Injectable()
export class IOvationService  {
  private _blackBoxId: string;

  public get blackBoxId(): Observable<string> {

    const o = new Observable<string>(observer => {

      // TODO: centralize this element's ID along with its ID in index.html.
      // This script tag is being referenced from the index.html.
      const iovationScriptElement = document.getElementById('IOvationScript') as HTMLScriptElement;

      // If we haven't retreived a blackBoxId yet from IOvation, then we want to grab one.
      if (!this._blackBoxId) {

        // These global variables need to be set prior to defining the IOvation script element src above
        // per their documentation.
        window['io_install_stm'] = false;   // do not install Active X
        window['io_exclude_stm'] = 12;      // do not run Active X
        window['io_install_flash'] = false; // do not install Flash
        window['io_enable_rip'] = true;     // collect Real IP information

        // IOvation callback configuration (io_bb_callback)
        // This function name needs to stay the same because it references
        // a function in IOvation.
        // This callback is for when the blackbox is finished and is ready to be used.
        window['io_bb_callback'] = (bb, isComplete) => {
          // We only want to send the blackbox information through
          // if it's finished processing.
          if (isComplete) {
            observer.next(bb);
            observer.complete();
          }
        };

        // In the event that the blackbox data takes a while to come back,
        // we want to set a maximum amount of time we're willing to wait for it before
        // giving up on waiting for all of the data to be collected.
        // At that point, we just send whatever is available.
        const maxMillisecondsWeAreWillingToWait: number = 5000;
        const getBlackBoxDataAvailable = () => {
          try {
            // Call ioGetBlackbox() from the IOvation snare.js we have
            // already loaded and then send that blackbox data back
            // to any subscribers.
            const blackBoxData = window['ioGetBlackbox']();

            observer.next(blackBoxData.blackbox as string);
            observer.complete();
            return;
          } catch (e) {
            // We're done processing the blackbox, but we got an error.
            // On error we want to send a blank blackbox per IOvation
            console.error(e);
            observer.error(e);
            observer.complete();
          }
        };
        // If we don't want to set a max wait time, simply comment this out.
        setTimeout(getBlackBoxDataAvailable, maxMillisecondsWeAreWillingToWait);

        // Set the <script> tag source in the index.html.
        iovationScriptElement.src = SETTINGS.IOVATION_SNARE_JS;
      } else {
        // If we have already processed a blackBoxId in the past, there's no reason
        // for us to go through and generate another one. Use the existing one and
        // mark the observable as completed.
        observer.next(this._blackBoxId);
        observer.complete();
      }
    });

    return o;
  }
}
